import React, { useState, useEffect } from 'react';
import { aboutContent, aboutBackgroundImages } from '@/data/mock';

// Carousel configuration
const CAROUSEL_INTERVAL_MS = 20000;

const AboutSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % aboutBackgroundImages.length
      );
    }, CAROUSEL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="about" className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden">
      {/* Background Image Carousel */}
      <div className="absolute inset-0 z-0">
        {aboutBackgroundImages.map((image, index) => (
          <div
            key={image.id}
            className={`absolute inset-0 transition-opacity duration-2000 ease-in-out ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image.url}
              alt={image.alt}
              className="w-full h-full object-cover scale-105 animate-ken-burns"
            />
          </div>
        ))}
        {/* Gradient overlay for text readability - more visible images */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/65 via-background/50 to-background/65" />
      </div>

      {/* Content */}
      <div className="container relative z-10 mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 animate-in fade-in duration-1000">
            {aboutContent.title}
          </h2>
          <p className="text-lg md:text-xl text-foreground leading-relaxed backdrop-blur-sm bg-background/40 p-6 rounded-2xl border border-border/30 shadow-xl animate-in fade-in duration-1000 delay-300">
            {aboutContent.content}
          </p>
        </div>
      </div>

      {/* Carousel Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {aboutBackgroundImages.map((image, index) => (
          <button
            key={image.id}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentImageIndex 
                ? 'bg-foreground w-8' 
                : 'bg-foreground/30 hover:bg-foreground/50'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default AboutSection;
